import React from 'react';

import CryptoJS from 'crypto-js';
import {jigsaw} from '@/utils/jigsaw/jigsaw';
import BaseClass from '@/pages/BaseClass';

import {authUrl, CommonValue, httpPost, message, ngUrl, pcUrl,} from '@/utils/tools';

export default class App extends BaseClass {
    constructor(props) {
        super(props);

        this.state = {
            'info': {
                'username': '',
                'password': '',
                'isRemember': false,
            },
            'showJigsawDialog': false,
            'zhuanye': 'lixue'
        };
    }

    componentDidMount() {
        let info = CommonValue.get('login_info');
        if (info) {
            let words = CryptoJS.enc.Base64.parse(info);
            info = words.toString(CryptoJS.enc.Utf8);
            info = JSON.parse(info);
            this.setState({
                info,
            });
        }
        this.checkLogin();

        global.setRootState({
            'hasLogin': false,
        });


        // var marqueeBox = document.getElementById("marquee-box");
        // var marquee = document.getElementById("marquee");
        // var marqueeCopy = document.getElementById("marquee-1");
        // marqueeCopy.innerHTML = marquee.innerHTML;

        // function fun() {
        //     //从右向左
        //     if (marqueeBox.scrollLeft >= 800) {
        //         marqueeBox.scrollLeft = 0;
        //     } else {
        //         marqueeBox.scrollLeft++;
        //     }
        // }

        // var fun1 = setInterval(fun, 20);
        //
        // marqueeBox.onmouseover = function () {
        //     clearInterval(fun1); //鼠标经过时  清除定时器  停止图片的滚动
        // };
        // marqueeBox.onmouseout = function () {
        //     fun1 = setInterval(fun, 20);  //鼠标离开后  继续滚动图片
        // };
    }

    checkLogin() {
        let url = pcUrl('/personal');

        httpPost(url, {}, 'get', {
            'rawCode': true,
        }).then(data => {
            //已经登录，直接进入首页
            this.props.history.push('/studyGuide');
            global.setRootState({
                'hasLogin': true,
            });
        });
    }

    showJigsaw() {
        return new Promise((resolve, reject) => {
            this.setState({
                'showJigsawDialog': true,
            }, () => {
                jigsaw.init({
                    el: document.getElementById("captcha"),
                    onSuccess: () => {
                        console.log("成功");
                        this.setState({
                            'showJigsawDialog': false,
                        });
                        resolve();
                    },
                    onFail: () => {
                        console.log("失败");
                        reject();
                    },
                    onRefresh: () => {
                        console.log("刷新");
                    },
                });
            });
        });
    }

    submit() {
        let url = authUrl('/login');
        let param = this.state.info;
        if (!param.username.length) {
            message('请输入用户名/卡号');
            this.usernameRef.focus();
            return false;
        }
        if (!param.password.length) {
            message('请输入密码/卡密');
            this.passwordRef.focus();
            return false;
        }

        // this.showJigsaw().then(() => {
            httpPost(url, param, 'POST', {
                'rawResponse': true,
            }).then(data => {
                CommonValue.set('token', data.token);
                if (param.isRemember) {
                    let loginInfo = {
                        'username': param.username,
                        'password': param.password,
                        'isRemember': param.isRemember,
                    };
                    loginInfo = JSON.stringify(loginInfo);

                    let wordArray = CryptoJS.enc.Utf8.parse(loginInfo);
                    loginInfo = CryptoJS.enc.Base64.stringify(wordArray);

                    CommonValue.set('login_info', loginInfo);
                }
                global.setRootState({
                    'hasLogin': true,
                });

                message('验证成功，正在登录', 'success');
                window.setTimeout(() => {
                    this.props.history.push('/studyGuide');
                }, 1200);
            });
        // });
    }

    render() {
        return (
            <>
                <div className="login-page">
                    <div className="login-body-1">
                        <div>
                            <div className="login-form">
                                <div className="captain">
                                    <h3>账号登录</h3>
                                </div>
                                <div className="form-body">
                                    <form onSubmit={e => {
                                        e.preventDefault();
                                        this.submit()
                                    }}>
                                        <div className="form-row">
                                            <div className="input-wrapper">
                                                <input ref={e => this.usernameRef = e} name="username"
                                                       value={this.state.info.username}
                                                       onChange={e => this.bindModel(e)}
                                                       className="input-text"
                                                       placeholder="请输入账号/卡号"/>
                                                <span className="before-node clips login-phone-ico"></span>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="input-wrapper">
                                                <input ref={e => this.passwordRef = e} name="password"
                                                       value={this.state.info.password}
                                                       onChange={e => this.bindModel(e)}
                                                       className="input-text"
                                                       type="password" placeholder="请输入密码/卡密"/>
                                                <span className="before-node clips login-password-ico"></span>
                                            </div>
                                        </div>
                                        <div className="form-row left">
                                            <a href={ngUrl('findPwd')}
                                               className="float-right text-blue">忘记密码</a>
                                            <label>
                                                <input type="checkbox" checked={this.state.info.isRemember}
                                                       onChange={e => {
                                                           this.changeInfo('isRemember', e.target.checked);
                                                       }}/>
                                                记住登录账号
                                            </label>
                                        </div>
                                        <div style={{'height': '1px'}}></div>
                                        <div className="form-row text-center" style={{'marginTop': '1em 0'}}>
                                            <button className="button submit-button button-blue">立即登录</button>
                                        </div>
                                        {/*<div className="text-center">*/}
                                            {/*<a href={ngUrl('register')} className="text-blue">注册账号</a>*/}
                                        {/*</div>*/}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="login-body-2">
                        <div className="login-title">研究性学习是新高考时代中学生的必修课</div>
                        <div className="login-content">
                            <img className="img1" src={require('@/assets/images/login/2_1.png')}/>
                            <img className="img2" src={require('@/assets/images/login/2_2.png')}/>
                            <img className="img3" src={require('@/assets/images/login/2_3.png')}/>
                        </div>
                    </div>
                    <div>
                        <hr className="div-split"/>
                    </div>
                    <div className="login-body-3">
                        <div className="login-title">
                            <div>创新工坊</div>
                            <div>新高考中学生在线研究性学习一站式解决方案</div>
                        </div>
                        <div className="login-content">
                            {/*<img className="" src={require('@/assets/images/login/3.png')}/>*/}
                            <div className="login-content-1">
                                <img className="img11" src={require('@/assets/images/login/3_11.png')}/>
                                <img className="img12" src={require('@/assets/images/login/3_12.png')}/>
                            </div>
                            <div className="login-content-2">
                                <img className="img21" src={require('@/assets/images/login/3_21.png')}/>
                                <img className="img22" src={require('@/assets/images/login/3_22.png')}/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <hr className="div-split"/>
                    </div>
                    <div className="login-body-zhuanye">
                        <div className="login-title">激发创新想象，打开学术视野，推动学术启蒙，培育科学素养</div>
                        <div className="login-title-min1">
                            <div className="login-title-min2">创新工坊现有百余个研究性学习和通用技术课题，覆盖40余个热门专业方向，</div>
                            <div className="login-title-min2">供学生个性化选择，助力学生轻松高效、高质量完成研究性学习，实现人人有课题，个个会创新。</div>
                        </div>
                        <div className="login-content">
                            <div className="login-content-tag">
                                <img src={require('@/assets/images/login/zhuanye/lixue/tag.png')}
                                     onMouseEnter={() => this.setState({zhuanye: "lixue"})}/>
                                <img src={require('@/assets/images/login/zhuanye/gongxue/tag.png')}
                                     onMouseEnter={() => this.setState({zhuanye: "gongxue"})}/>
                                <img src={require('@/assets/images/login/zhuanye/renwen/tag.png')}
                                     onMouseEnter={() => this.setState({zhuanye: "renwen"})}/>
                                <img src={require('@/assets/images/login/zhuanye/shehui/tag.png')}
                                     onMouseEnter={() => this.setState({zhuanye: "shehui"})}/>
                                <img src={require('@/assets/images/login/zhuanye/jingji/tag.png')}
                                     onMouseEnter={() => this.setState({zhuanye: "jingji"})}/>
                            </div>
                            <div className="login-content-main">
                                {this.state.zhuanye && (
                                    <>
                                        <div className="login-content-sub">
                                            <div className="login-content-left">
                                                <img
                                                    src={require('@/assets/images/login/zhuanye/' + this.state.zhuanye + '/left.png')}/>
                                            </div>
                                            <div className="login-content-right">
                                                <div className="login-content-right-1">
                                                    <img
                                                        src={require('@/assets/images/login/zhuanye/' + this.state.zhuanye + '/01.png')}/>
                                                    <img
                                                        src={require('@/assets/images/login/zhuanye/' + this.state.zhuanye + '/02.png')}/>
                                                    <img
                                                        src={require('@/assets/images/login/zhuanye/' + this.state.zhuanye + '/03.png')}/>
                                                </div>
                                                <div className="login-content-right-1">
                                                    <img
                                                        src={require('@/assets/images/login/zhuanye/' + this.state.zhuanye + '/04.png')}/>
                                                    <img
                                                        src={require('@/assets/images/login/zhuanye/' + this.state.zhuanye + '/05.png')}/>
                                                    <img
                                                        src={require('@/assets/images/login/zhuanye/' + this.state.zhuanye + '/06.png')}/>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    {/*<div className="login-body-school">
                        <div className="login-title">
                            <div>服务学员覆盖</div>
                        </div>
                        <div className="login-content" id="marquee-box">
                            <div id="marquee-con">
                                <div id="marquee-1"></div>
                                <div id="marquee">
                                    <div className="login-content-sub">
                                        <img src={require('@/assets/images/login/xuexiao/01.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/02.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/03.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/04.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/05.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/06.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/07.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/08.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/09.png')}/>
                                    </div>
                                    <div className="login-content-sub">
                                        <img src={require('@/assets/images/login/xuexiao/10.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/11.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/12.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/13.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/14.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/15.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/16.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/17.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/18.png')}/>
                                    </div>
                                    <div className="login-content-sub">
                                        <img src={require('@/assets/images/login/xuexiao/19.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/20.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/21.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/22.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/23.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/24.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/25.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/26.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/27.png')}/>
                                    </div>
                                    <div className="login-content-sub">
                                        <img src={require('@/assets/images/login/xuexiao/28.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/29.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/30.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/31.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/32.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/33.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/34.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/35.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/36.png')}/>
                                    </div>
                                    <div className="login-content-sub">
                                        <img src={require('@/assets/images/login/xuexiao/37.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/38.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/39.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/40.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/41.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/42.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/43.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/44.png')}/>
                                        <img src={require('@/assets/images/login/xuexiao/45.png')}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>*/}

                    <div className="login-body-student">
                        <div className="login-title">优秀学员心得</div>
                        <div className="login-content">
                            <img src={require('@/assets/images/login/xueyuan/01.png')}/>
                            <img src={require('@/assets/images/login/xueyuan/02.png')}/>
                            <img src={require('@/assets/images/login/xueyuan/03.png')}/>
                        </div>
                    </div>

                </div>
                {/*</div>*/}

                {
                    this.state.showJigsawDialog && (
                        <>
                            <div className="mask"></div>
                            <div className="modal">
                                <div className="jigsaw-modal">
                                    <div id="captcha"></div>
                                </div>
                            </div>
                        </>
                    )
                }
            </>
        )
            ;
    }
}
